export default __webpack_public_path__ + "static/mp1-29bea63aecf8acc938442c987db2a179.jpg";